import React, { useState, useEffect } from 'react'
import Item from './Item'
import Quantity from './Quantity'
import Container from '../../layout/container'
import { ExportCSV } from './ExportCSV'
import icoLoading from '../../assets/icoLoading.svg'
import {
  RegistersStyle,
  RegisterMenu,
  Title,
  SubTitle,
  List,
  InputDate,
  Filters,
  ButtonFilter,
  Loading,
  Paginating,
  ResendButton
} from './style'
import ModalResend from './ModalResend'

export default function Registers() {
  const [links, setLinks] = useState([])
  const [qty, setQty] = useState()
  const [filter, setFilter] = useState()
  const [values, setValues] = useState({})
  const [loading, setLoading] = useState(false)
  const [resendList, setResendList] = useState([])
  const [token, setToken] = useState()
  const [showResendModal, setShowResendModal] = useState(false)
  const [mainCheck, setMainCheck] = useState(false)

  const loadLinks = async () => {
    try {
      const res = await fetch('/.netlify/functions/getLinks')
      const links = await res.json()

      setLinks(links)
    } catch (err) {
      console.error(err)
    }
  }

  const filterByDate = async (size) => {
    const body = { size }

    setLoading(true)
    setMainCheck(false)
    setResendList([])

    let dateStart = new Date(values.dateStart)
    let dateEnd = new Date(values.dateEnd)

    try {
      let equifax = await fetch('/.netlify/functions/getFilterByDate', {
        method: 'POST',
        body: JSON.stringify(body)
      })

      let equifaxResult = equifax.text()

      equifaxResult.then(function (result) {
        let resulting = JSON.parse(result)
        let data = []

        let filteredData = resulting.data.filter(
          (a) =>
            new Date(a.dateRegister).getTime() >= dateStart.getTime() &&
            new Date(a.dateRegister).getTime() <= dateEnd.getTime()
        )

        let dataConcat = { data: data.concat(filteredData) }

        setLinks(dataConcat)
        setQty(dataConcat.data.length)
        setFilter(true)
        setLoading(false)
      })
    } catch (error) {
      console.error(error)
    }
  }

  const pagination = async (cursor, size) => {
    const body = { cursor, size }
    setResendList([])

    try {
      const equifax = await fetch('/.netlify/functions/getLinksPag', {
        method: 'POST',
        body: JSON.stringify(body)
      })
      const equifaxResult = await equifax.json()

      setLinks(equifaxResult)
    } catch (error) {
      console.error(error)
    }
  }

  const _qty = async (cursor, size) => {
    const body = { cursor, size }

    try {
      const equifax = await fetch('/.netlify/functions/getLinksPag', {
        method: 'POST',
        body: JSON.stringify(body)
      })
      const equifaxResult = await equifax.json()

      setQty(equifaxResult.data.length)
    } catch (error) {
      console.error(error)
    }
  }

  const handleChange = (event) => {
    event.persist()
    setValues((values) => ({ ...values, [event.target.name]: event.target.value }))
  }

  const handleResendList = (link, checked) => {
    if (checked) {
      setResendList([...resendList, link])
    } else {
      const newArray = resendList.filter((el) => el._id !== link._id)
      setResendList(newArray)
    }

    uncheckItems()
  }

  const uncheckItems = () => {
    let checkboxes = document.querySelectorAll('.check-items')
    let arr = []
    checkboxes.forEach((el) => (el.checked === true ? arr.push(el) : ''))

    if (arr.length === 0) {
      setMainCheck(false)
    }
  }

  const getTokens = async () => {
    try {
      const res = await fetch('/.netlify/functions/getToken')
      const tokens = await res.json()
      setToken(tokens.access_token)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    loadLinks()
    getTokens()
    _qty(undefined, 9000)
  }, [])

  const checkAll = (check, type) => {
    let checkboxes = document.querySelectorAll('.check-items')

    if (type !== 'modal') {
      setMainCheck(!mainCheck)
    }

    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = check
    }

    if (check) {
      setResendList(links.data)
    } else {
      setResendList([])
    }
  }

  return (
    <React.Fragment>
      <RegistersStyle>
        <RegisterMenu>
          <a href="/dashboard">Inscrição</a>
        </RegisterMenu>
        <Container WidthSize="80%" Margin="0px">
          <ResendButton disabled={resendList.length <= 0} onClick={(_) => setShowResendModal(true)}>
            Reenviar Equifax
          </ResendButton>
          <Title>Status de Inscripción</Title>

          <Filters>
            <Quantity links={qty} />

            {/* Date */}
            <InputDate>
              <label>
                <span>Fecha de inicio</span>

                <input
                  type="datetime-local"
                  name="dateStart"
                  className={``}
                  value={values.dateStart || ''}
                  onChange={handleChange}
                />
              </label>

              <label>
                <span>Fecha final</span>
                <input
                  type="datetime-local"
                  name="dateEnd"
                  className={``}
                  value={values.dateEnd || ''}
                  onChange={handleChange}
                />
              </label>

              {values.dateStart && values.dateEnd ? (
                <ButtonFilter onClick={() => filterByDate(9000)}>Filtro</ButtonFilter>
              ) : (
                ''
              )}

              {filter && loading === false ? <ExportCSV data={links.data} /> : ''}
            </InputDate>
            {/* /Date */}
          </Filters>

          <List>
            <div className="align-title-table">
              <SubTitle>Suscripcións</SubTitle>

              {(links && links.pBefore) || links.pAfter ? (
                <Paginating>
                  {links && links.pBefore ? (
                    <span id={links.pBefore} onClick={() => pagination(links.pBefore, 10)}>
                      &lt; Before
                    </span>
                  ) : (
                    ''
                  )}

                  {links && links.pAfter ? (
                    <span id={links.pAfter} onClick={() => pagination(links.pAfter, 10)}>
                      After &gt;
                    </span>
                  ) : (
                    ''
                  )}
                </Paginating>
              ) : (
                ''
              )}
            </div>

            {loading ? (
              <Loading>
                <img src={icoLoading} alt="Loading..." title="Loading..." />
              </Loading>
            ) : (
              <table>
                <thead>
                  <tr>
                    <td style={{ padding: '0px 5px' }}>
                      <input
                        type="checkbox"
                        onChange={(e) => checkAll(e.target.checked)}
                        checked={mainCheck}
                        style={{ cursor: 'pointer' }}
                      />
                    </td>
                    <td>Identificacion</td>
                    <td>Nombres</td>
                    <td>Email</td>
                    <td>Fecha de registro</td>
                    <td>Status</td>
                    <td>Equifax</td>
                  </tr>
                </thead>
                <tbody>
                  {links &&
                    links.data &&
                    links.data.map((link, index) => (
                      <Item
                        key={link._id}
                        link={link}
                        index={index}
                        refreshLinks={loadLinks}
                        handleResend={handleResendList}
                      />
                    ))}
                </tbody>
              </table>
            )}
          </List>
        </Container>
      </RegistersStyle>
      {showResendModal && (
        <ModalResend
          list={resendList}
          closeModal={setShowResendModal}
          token={token}
          mainLinks={links}
          setResendList={setResendList}
          setMainCheck={setMainCheck}
          checkAll={checkAll}
          setLinks={setLinks}
        />
      )}
    </React.Fragment>
  )
}
